// src/menu-items/Admin.js
import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
// import Inventory2Icon from "@mui/icons-material/Inventory2";
import RequestPageIcon from "@mui/icons-material/RequestPage";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import RemoveShoppingCartIcon from "@mui/icons-material/RemoveShoppingCart";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import SellIcon from "@mui/icons-material/Sell";
import OutboxIcon from "@mui/icons-material/Outbox";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import StoreIcon from "@mui/icons-material/Store";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SummarizeIcon from "@mui/icons-material/Summarize";
import SwapHorizontalCircleIcon from "@mui/icons-material/SwapHorizontalCircle";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DirectionsCarFilledIcon from "@mui/icons-material/DirectionsCarFilled";
import { hasPermission } from "../utils/permissionUtils";
import { useAuth } from "hooks/useAuth";
import { CarCrash, Description } from "@mui/icons-material";

const CarRoutes = () => {
  const { role } = useAuth();

  const generateAdminRoutes = () => {
    const carRoutes = [
      /* Dashboard Menu */

      {
        title: "Dashboard",
        items: [
          {
            path: "/car/dashboard_cars",
            name: "Dashboard",
            icon: <DashboardIcon />,
          },
        ],
      },

      /* หมวดหมู่สินค้า รถมือสอง */

      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "สินค้า",
        items: [
          {
            path: "/car/all_cars",
            name: "รถทั้งหมด",
            icon: <DirectionsCarFilledIcon />,
          },
          {
            path: "/car/buy_cars",
            name: "รถที่ซื้อแล้ว",
            icon: <RequestPageIcon />,
          },
          {
            path: "/car/ready_cars",
            name: "รถพร้อมขาย",
            icon: <ShoppingCartIcon />,
          },
          {
            path: "/car/sold_cars",
            name: "รถขายแล้ว",
            icon: <RemoveShoppingCartIcon />,
          },
        ],
      },

      /* หมวดหมู่รายการ รถมือสอง */

      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "รายการ",
        items: [
          {
            path: "/car/pawn_cars",
            name: "รายการขายฝาก (จำนำ)",
            icon: <SellIcon />,
          },
          {
            path: "/car/redemption_cars",
            name: "รายการไถ่ถอน",
            icon: <OutboxIcon />,
          },
          {
            path: "/car/repossessed_cars",
            name: "รถหลุดจำนำ",
            icon: <HourglassBottomIcon />,
          },
          {
            path: "/car/consignment_cars",
            name: "รถฝากขาย",
            icon: <DirectionsCarFilledIcon />,
          },
          {
            path: "/car/documents",
            name: "ฟอร์มเอกสาร",
            icon: <Description />,
          },
          // {
          //   path: "/car/setting_price_cars",
          //   name: "ตั้งค่าราคาขาย",
          //   icon: <PaidIcon />,
          // },
          {
            path: "/car/list_by_customer_cars",
            name: "รายการแยกตามชื่อลูกค้า",
            icon: <ContactPageIcon />,
          },
          { path: "/car/bin_cars", name: "ถังขยะ", icon: <DeleteIcon /> },
          {
            path: "/car/customer_list_cars",
            name: "รายชื่อลูกค้า",
            icon: <PeopleAltIcon />,
          },
        ],
      },

      // /* หมวดหมู่รายงาน รถมือสอง */

      hasPermission(role, ["admin", "AdminA", "AdminM", "owner"]) && {
        title: "รายงาน",
        items: [
          {
            path: "/car/inventory_cars",
            name: "ทรัพย์คงคลัง",
            icon: <StoreIcon />,
          },
          {
            path: "/car/income_expenses_cars",
            name: "รายรับ",
            icon: <PriceChangeIcon />,
          },
          {
            path: "/car/interest_cars",
            name: "ดอกเบี้ย",
            icon: <TrendingUpIcon />,
          },
        ],
      },
    ].filter(Boolean);

    return carRoutes;
  };

  return generateAdminRoutes(); // Call the function to get the routes
};

export default CarRoutes;
